import { APPLICATION_BANK_STATUS_KKB } from "../../utils/guards/ApplicationBankStatusGuard/types";

export const bankStatusesForSign: string[] = [
  APPLICATION_BANK_STATUS_KKB.SIGNING,
  APPLICATION_BANK_STATUS_KKB.RESIGNING,
  APPLICATION_BANK_STATUS_KKB.SIGNATURE_REQUIRED,
];
